class ProductCustomization {
  constructor(container) {
    this.container = container;
    this.textInput = container.querySelector('[data-customization-text]');
    this.fontSelect = container.querySelector('[data-customization-font]');
    
    console.log('ProductCustomization initialisé', this.textInput, this.fontSelect);
    
    this.init();
  }
  
  init() {
    if (!this.textInput || !this.fontSelect) {
      console.log('Champs manquants');
      return;
    }
    
    this.fontSelect.addEventListener('change', () => {
      console.log('Police sélectionnée:', this.fontSelect.value);
      this.applyFont();
    });
  }
  
  applyFont() {
    const font = this.fontSelect.value;
    
    console.log('Application de la police:', font);
    
    // Retirer toutes les classes de police existantes
    const currentClasses = this.textInput.className.split(' ');
    const filteredClasses = currentClasses.filter(c => !c.startsWith('font-'));
    this.textInput.className = filteredClasses.join(' ');
    
    // Ajouter la nouvelle classe de police
    if (font) {
      const fontClass = 'font-' + this.sanitizeFontName(font);
      console.log('Classe appliquée:', fontClass);
      this.textInput.classList.add(fontClass);
    }
  }
  
  sanitizeFontName(name) {
    const sanitized = name.toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');
    
    console.log('Nom sanitizé:', name, '->', sanitized);
    return sanitized;
  }
}

// Initialisation
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM chargé, recherche des modules de personnalisation...');
  
  const containers = document.querySelectorAll('[data-product-customization]');
  console.log('Containers trouvés:', containers.length);
  
  containers.forEach(container => {
    new ProductCustomization(container);
  });
});
